import { TDynamicStoreField } from '../../../store/store';
import { TUserRegistrationData } from '../../../types/types';
import { COOKIE_NAMES } from '../../../utils/constants';
import { getCookieByName } from '../../../utils/cookies';
import { separateBirthdate } from '../../../utils/utils';

export const adaptMgaGraRegistrationUserData = (
  registrationData: TDynamicStoreField | null,
  marketCode: string,
) => {
  if (registrationData) {
    const birthdate = separateBirthdate(registrationData.dateOfBirth);

    const result: TUserRegistrationData = {
      ...registrationData,
      ...birthdate,
      limit:      null, // TODO: implement limit data when component is ready.
      trackingId: getCookieByName(COOKIE_NAMES.KAZUMO_TRACKING_ID),
      marketCode,
      address:    {
        ...registrationData?.address,
        isVerified: registrationData.address?.isVerified || true,
      },
      phoneVerified: false,

      subscribeToMarketingMaterial: // TODO: Implement logic so we can get this info properly.
        registrationData?.marketingConsent || false,

    };

    return result;
  }

  return null;
};
